/* THRONE × UPCART — assets/throne-upcart.js
   Upcart keeps all cart logic. This file only tags/reorders its injected DOM
   and connects the THRONE header cart buttons to Upcart.
*/
(() => {
  const CLOSE_ICON =
    'https://cdn.shopify.com/s/files/1/0914/0951/4777/files/Vector_5.svg?v=1786215902';
  const REMOVE_ICON =
    'https://cdn.shopify.com/s/files/1/0914/0951/4777/files/Vector_6.svg?v=1786218156';

  let busy = false;
  let timer = null;

  const txt = (el) =>
    ((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim();

  const visible = (el) => {
    if (!el || !(el instanceof Element)) return false;
    const s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden';
  };

const findDrawer = (popup) => {
  /* Exact Upcart drawer used by the current store/version */
  const cartPopup =
    document.querySelector('#CartPopup') ||
    popup.querySelector('#CartPopup');

  if (cartPopup) {
    return cartPopup;
  }

  /* Fallback for other Upcart versions */
  const body =
    popup.querySelector('.upcart-cart-body') ||
    popup.querySelector('[class*="CartPreview__body"]');

  if (!body) return null;

  return (
    body.closest('.upcart-internal-cart-preview__container') ||
    body.closest('[class*="CartPreview__position-fixed"]') ||
    body.parentElement
  );
};

  const findNativeClose = (drawer) =>
    Array.from(drawer.querySelectorAll('button,[role="button"]')).find((el) => {
      const aria = (el.getAttribute('aria-label') || '').toLowerCase();
      const t = txt(el).toLowerCase();
      return aria.includes('close') || t === '×' || t === 'x';
    });

  const ensureHeader = (drawer) => {
    let header = drawer.querySelector('.throne-upcart__header');
    if (header) return header;

    header = document.createElement('div');
    header.className = 'throne-upcart__header';

    const title = document.createElement('h2');
    title.className = 'throne-upcart__title';
    title.innerHTML = 'MY CART (<span data-throne-title-count>0</span>)';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'throne-upcart__close';
    close.setAttribute('aria-label', 'Close cart');
    close.innerHTML = `<img src="${CLOSE_ICON}" alt="" width="19" height="19">`;

    close.addEventListener('click', () => {
      const nativeClose = findNativeClose(drawer);
      if (nativeClose && nativeClose !== close) nativeClose.click();
    });

    header.append(title, close);
    drawer.prepend(header);
    return header;
  };

  const tagNativeHeader = (drawer) => {
    const close = findNativeClose(drawer);
    if (!close) return;

    let node = close.parentElement;
    for (let i = 0; i < 4 && node && node !== drawer; i += 1) {
      const r = node.getBoundingClientRect();
      if (r.height <= 130 && /cart/i.test(txt(node))) {
        node.setAttribute('data-throne-native-header', '');
        return;
      }
      node = node.parentElement;
    }
  };

  const cartCount = (popup) => {
    const possible = Array.from(
      popup.querySelectorAll('h1,h2,h3,div,span')
    ).find((el) => /\bcart\b/i.test(txt(el)) && /\d/.test(txt(el)));

    if (possible) {
      const m = txt(possible).match(/(?:cart[^\d]*|[\(\s])(\d+)\)?/i);
      if (m) return Number(m[1]) || 0;
    }

    const badge = document.querySelector('[data-cart-count]');
    if (badge) return Number(badge.textContent.trim()) || 0;

    const list = popup.querySelector('.upcart-public-cart-items');
    return list ? list.children.length : 0;
  };

  const updateCount = (popup, drawer) => {
    const target = drawer.querySelector('[data-throne-title-count]');
    if (target) target.textContent = String(cartCount(popup));
  };

  const leafTextNodes = (root) =>
    Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div,a')).filter(
      (el) => {
        if (!visible(el)) return false;
        const t = txt(el);
        if (!t || t.length > 220) return false;
        return Array.from(el.children).every((child) => txt(child) !== t);
      }
    );

  const tagToggleModule = (module, type) => {
    if (!module) return;

    const nodes = leafTextNodes(module);
    const titleRegex =
      type === 'subscription'
        ? /save .*subscription|with subscription/i
        : /shipping protection/i;

    const title = nodes.find((el) => titleRegex.test(txt(el)));
    if (title) {
      title.setAttribute('data-throne-module-title', '');

      if (!title.querySelector('[data-throne-highlight]')) {
        const raw = title.textContent || '';
        const money = raw.match(/\$[\d,.]+/);
        if (money) {
          const before = raw.slice(0, money.index);
          const after = raw.slice(money.index + money[0].length);
          title.textContent = '';
          title.append(document.createTextNode(before));

          const hi = document.createElement('span');
          hi.setAttribute('data-throne-highlight', '');
          hi.textContent = money[0];

          title.append(hi, document.createTextNode(after));
        }
      }
    }

    const subtitle =
      type === 'subscription'
        ? nodes.find(
            (el) =>
              el !== title &&
              /(deliver every|save .*%|subscription)/i.test(txt(el)) &&
              txt(el).length > 12
          )
        : nodes.find(
            (el) =>
              el !== title &&
              /(protect your order|damage|loss|theft)/i.test(txt(el))
          );

    if (subtitle) {
      subtitle.setAttribute('data-throne-module-subtitle', '');
    }

    if (type === 'shipping') {
      const price = nodes.find((el) => /^\$[\d,.]+/.test(txt(el)));
      if (price) {
        price.setAttribute('data-throne-module-price', '');
      }
    }

    const controls = Array.from(
      module.querySelectorAll('button,[role="switch"],input[type="checkbox"]')
    );

    const inputOrSwitch =
      controls.find((el) => el.getAttribute('role') === 'switch') ||
      controls.find((el) => el.matches('input[type="checkbox"]')) ||
      controls.find((el) => {
        const r = el.getBoundingClientRect();
        return r.width >= 35 && r.width <= 80 && r.height <= 40;
      });

    if (inputOrSwitch) {
      const visual =
        inputOrSwitch.matches('input') && inputOrSwitch.parentElement
          ? inputOrSwitch.parentElement
          : inputOrSwitch;

      visual.setAttribute('data-throne-toggle', '');

      const active =
        inputOrSwitch.checked === true ||
        inputOrSwitch.getAttribute('aria-checked') === 'true' ||
        inputOrSwitch.getAttribute('aria-pressed') === 'true';

      visual.classList.toggle('is-active', active);

      if (title) {
        let common = title.parentElement;

        while (
          common &&
          common !== module &&
          !common.contains(inputOrSwitch)
        ) {
          common = common.parentElement;
        }

        (common && common !== module ? common : module).setAttribute(
          'data-throne-module-row',
          ''
        );
      }
    }
  };

  const smallestMatchingBlock = (root, regex, exclude) => {
    const matches = Array.from(
      root.querySelectorAll('div,section,article,li')
    )
      .filter((el) => {
        if (!visible(el)) return false;
        if (exclude && exclude.contains(el)) return false;

        const t = txt(el);

        return regex.test(t) && t.length < 420;
      })
      .sort(
        (a, b) =>
          a.getBoundingClientRect().height -
          b.getBoundingClientRect().height
      );

    return matches[0] || null;
  };

  const tagSubscription = (drawer, items) => {
    const module = smallestMatchingBlock(
      drawer,
      /save .*subscription|with subscription|deliver every month/i,
      items
    );

    if (!module) return null;

    module.setAttribute('data-throne-subscription', '');
    tagToggleModule(module, 'subscription');

    return module;
  };

  const tagShipping = (drawer, items) => {
    const module =
      drawer.querySelector('.upcart-public-addons') ||
      smallestMatchingBlock(
        drawer,
        /shipping protection|protect your order/i,
        items
      );

    if (!module) return null;

    module.setAttribute('data-throne-shipping-protection', '');
    tagToggleModule(module, 'shipping');

    return module;
  };

  const tagDiscount = (drawer) => {
    const input = Array.from(
      drawer.querySelectorAll('input')
    ).find((el) => {
      const p = (el.getAttribute('placeholder') || '').toLowerCase();

      return p.includes('discount') || p.includes('promo');
    });

    if (!input) return null;

    let area = input.parentElement;

    for (
      let i = 0;
      i < 4 && area && area !== drawer;
      i += 1
    ) {
      if (area.querySelector('button')) break;
      area = area.parentElement;
    }

    if (!area || area === drawer) return null;

    area.setAttribute('data-throne-discount', '');

    return area;
  };

  const tagCheckout = (drawer) => {
    const btn = Array.from(
      drawer.querySelectorAll('button,a,[role="button"]')
    ).find(
      (el) =>
        visible(el) &&
        /checkout/i.test(txt(el))
    );

    if (!btn) return null;

    btn.setAttribute('data-throne-checkout', '');

    return btn;
  };

  const tagFooter = (drawer, checkout) => {
    let footer =
      drawer.querySelector('.upcart-footer') ||
      drawer.querySelector('[class*="Footer"]');

    if (!footer && checkout) {
      footer = checkout.parentElement;

      while (footer && footer !== drawer) {
        const t = txt(footer);

        if (
          /discount|shipping protection|checkout/i.test(t)
        ) {
          break;
        }

        footer = footer.parentElement;
      }
    }

    if (!footer || footer === drawer) {
      footer = document.createElement('div');
      drawer.appendChild(footer);
    }

    footer.setAttribute('data-throne-footer', '');

    return footer;
  };

  const tagRewards = (drawer) => {
    const rewards =
      drawer.querySelector('.upcart-public-rewards') ||
      drawer.querySelector('.upcart-internal-rewards');

    if (!rewards) return null;

    rewards.setAttribute('data-throne-rewards', '');

    const message = Array.from(
      rewards.querySelectorAll('div,p,span')
    )
      .filter(
        (el) =>
          visible(el) &&
          /free shipping/i.test(txt(el))
      )
      .sort(
        (a, b) =>
          txt(a).length - txt(b).length
      )[0];

    if (message) {
      message.setAttribute(
        'data-throne-reward-message',
        ''
      );

      if (
        !message.querySelector(
          '[data-throne-highlight]'
        )
      ) {
        const raw = message.textContent || '';
        const money = raw.match(/\$[\d,.]+/);

        if (money) {
          const before = raw.slice(
            0,
            money.index
          );

          const after = raw.slice(
            money.index + money[0].length
          );

          message.textContent = '';

          message.append(
            document.createTextNode(before)
          );

          const hi =
            document.createElement('span');

          hi.setAttribute(
            'data-throne-highlight',
            ''
          );

          hi.textContent = money[0];

          message.append(
            hi,
            document.createTextNode(after)
          );
        }
      }
    }

    const thin = Array.from(
      rewards.querySelectorAll('div,span')
    ).filter((el) => {
      const r = el.getBoundingClientRect();

      return (
        visible(el) &&
        r.width > 100 &&
        r.height > 0 &&
        r.height <= 8
      );
    });

    if (thin.length) {
      const track = thin.sort(
        (a, b) =>
          b.getBoundingClientRect().width -
          a.getBoundingClientRect().width
      )[0];

      track.setAttribute(
        'data-throne-progress-track',
        ''
      );

      const fill = Array.from(
        track.children
      ).find((el) => {
        const r =
          el.getBoundingClientRect();

        return (
          r.width > 0 &&
          r.height <= 8
        );
      });

      if (fill) {
        fill.setAttribute(
          'data-throne-progress-fill',
          ''
        );
      }
    }

    Array.from(
      rewards.querySelectorAll('div,span')
    ).forEach((el) => {
      const r = el.getBoundingClientRect();

      if (
        el.querySelector('svg,img') &&
        r.width >= 18 &&
        r.width <= 46 &&
        r.height >= 18 &&
        r.height <= 46
      ) {
        el.setAttribute(
          'data-throne-milestone',
          ''
        );
      }
    });

    return rewards;
  };

  const tagItems = (drawer) => {
    const list =
      drawer.querySelector('.upcart-public-cart-items') ||
      drawer.querySelector('.upcart-internal-cart-items');

    if (!list) return null;

    list.setAttribute(
      'data-throne-items-list',
      ''
    );

    Array.from(list.children).forEach((item) => {
      if (!(item instanceof Element)) return;

      item.setAttribute(
        'data-throne-cart-item',
        ''
      );

      const productImage = Array.from(
        item.querySelectorAll('img')
      )
        .filter(visible)
        .map((img) => ({
          img,
          area:
            img.getBoundingClientRect().width *
            img.getBoundingClientRect().height
        }))
        .filter(({ area }) => area > 900)
        .sort(
          (a, b) =>
            b.area - a.area
        )[0]?.img;

      if (productImage) {
        productImage.setAttribute(
          'data-throne-product-image',
          ''
        );

        if (
          productImage.parentElement
        ) {
          productImage.parentElement.setAttribute(
            'data-throne-product-image-wrap',
            ''
          );
        }
      }

      const buttons = Array.from(
        item.querySelectorAll(
          'button,[role="button"]'
        )
      );

      let remove = buttons.find((el) => {
        const aria =
          (
            el.getAttribute('aria-label') ||
            ''
          ).toLowerCase();

        return (
          aria.includes('remove') ||
          aria.includes('delete')
        );
      });

      if (!remove) {
        remove = buttons.find((el) => {
          const r =
            el.getBoundingClientRect();

          return (
            r.width <= 40 &&
            r.height <= 40 &&
            !!el.querySelector('svg')
          );
        });
      }

      if (remove) {
        remove.setAttribute(
          'data-throne-remove',
          ''
        );

        if (
          !remove.querySelector(
            '[data-throne-remove-icon]'
          )
        ) {
          Array.from(
            remove.children
          ).forEach((child) => {
            child.style.display = 'none';
          });

          const img =
            document.createElement('img');

          img.src = REMOVE_ICON;
          img.alt = '';
          img.width = 14;
          img.height = 14;

          img.setAttribute(
            'data-throne-remove-icon',
            ''
          );

          remove.appendChild(img);
        }
      }

      let quantity = Array.from(
        item.querySelectorAll('div,form')
      ).find((el) => {
        return (
          el.querySelectorAll('button')
            .length >= 2 &&
          !!el.querySelector('input')
        );
      });

      if (!quantity) {
        quantity = Array.from(
          item.querySelectorAll('div')
        ).find((el) => {
          const t = txt(el);

          return (
            el.querySelectorAll('button')
              .length >= 2 &&
            /^[\s+\-0-9]+$/.test(t)
          );
        });
      }

      if (quantity) {
        quantity.setAttribute(
          'data-throne-quantity',
          ''
        );

        if (
          !quantity.querySelector('input')
        ) {
          const value = Array.from(
            quantity.querySelectorAll(
              'span,div'
            )
          ).find((el) =>
            /^\d+$/.test(txt(el))
          );

          if (value) {
            value.setAttribute(
              'data-throne-quantity-value',
              ''
            );
          }
        }
      }

      const leaves =
        leafTextNodes(item).filter((el) => {
          if (
            quantity &&
            quantity.contains(el)
          ) {
            return false;
          }

          if (
            remove &&
            remove.contains(el)
          ) {
            return false;
          }

          return true;
        });

      const price = leaves
        .filter((el) =>
          /\$\s*[\d,.]+/.test(txt(el))
        )
        .sort(
          (a, b) =>
            txt(a).length -
            txt(b).length
        )[0];

      if (price) {
        price.setAttribute(
          'data-throne-product-price',
          ''
        );
      }

      const variant = leaves.find(
        (el) =>
          /\b(ml|oz|fl\.?\s*oz|size|pack)\b/i.test(
            txt(el)
          ) &&
          !/\$/.test(txt(el))
      );

      if (variant) {
        variant.setAttribute(
          'data-throne-product-variant',
          ''
        );
      }

      const title = leaves
        .filter((el) => {
          const t = txt(el);

          return (
            el !== price &&
            el !== variant &&
            !/\$/.test(t) &&
            !/remove|delete|subscription/i.test(
              t
            ) &&
            t.length >= 5 &&
            t.length <= 90
          );
        })
        .sort((a, b) => {
          const aw =
            parseInt(
              getComputedStyle(a).fontWeight,
              10
            ) || 400;

          const bw =
            parseInt(
              getComputedStyle(b).fontWeight,
              10
            ) || 400;

          return (
            bw - aw ||
            txt(b).length -
              txt(a).length
          );
        })[0];

      if (title) {
        title.setAttribute(
          'data-throne-product-title',
          ''
        );
      }

      const anchors = [
        title,
        variant,
        quantity
      ].filter(Boolean);

      if (anchors.length) {
        let info =
          anchors[0].parentElement;

        while (
          info &&
          info !== item &&
          !anchors.every((node) =>
            info.contains(node)
          )
        ) {
          info =
            info.parentElement;
        }

        if (
          info &&
          info !== item
        ) {
          info.setAttribute(
            'data-throne-item-info',
            ''
          );
        }
      }
    });

    return list;
  };

  const hideNonFigmaFooter = (
    footer,
    keep
  ) => {
    if (!footer) return;

    const whitelist = new Set(
      keep.filter(Boolean)
    );

    Array.from(
      footer.children
    ).forEach((child) => {
      if (
        whitelist.has(child)
      ) {
        return;
      }

      const t = txt(child);

      if (
        /\bsubtotal\b/i.test(t) ||
        /continue shopping/i.test(t)
      ) {
        child.setAttribute(
          'data-throne-hide',
          ''
        );
      }
    });
  };

  const applySkin = () => {
    if (busy) return;

    const popup =
  document.querySelector('#UpcartPopup') ||
  document.querySelector('#CartPopup');

if (!popup) return;

    if (!popup) return;

    const drawer =
      findDrawer(popup);

    if (!drawer) return;

    busy = true;

    try {
      drawer.setAttribute(
        'data-throne-upcart-drawer',
        ''
      );

      tagNativeHeader(drawer);
      ensureHeader(drawer);
      updateCount(
        popup,
        drawer
      );

      const body =
        drawer.querySelector(
          '.upcart-cart-body'
        ) ||
        drawer.querySelector(
          '[class*="CartPreview__body"]'
        );

      if (body) {
        body.setAttribute(
          'data-throne-cart-body',
          ''
        );
      }

      const items =
        tagItems(drawer);

      const subscription =
        tagSubscription(
          drawer,
          items
        );

      const shipping =
        tagShipping(
          drawer,
          items
        );

      const discount =
        tagDiscount(drawer);

      const checkout =
        tagCheckout(drawer);

      const rewards =
        tagRewards(drawer);

      const footer =
        tagFooter(
          drawer,
          checkout
        );

      /* Exact Figma order.
         Moving existing nodes keeps
         Upcart handlers alive. */
      if (
        body &&
        subscription &&
        items
      ) {
        body.insertBefore(
          subscription,
          items
        );
      }

      [
        discount,
        shipping,
        checkout,
        rewards
      ].forEach((node) => {
        if (
          node &&
          footer
        ) {
          footer.appendChild(node);
        }
      });

      hideNonFigmaFooter(
        footer,
        [
          discount,
          shipping,
          checkout,
          rewards
        ]
      );
    } finally {
      busy = false;
    }
  };

  const scheduleApply = () => {
    clearTimeout(timer);

    timer = setTimeout(
      applySkin,
      70
    );
  };

  /* Custom THRONE header → Upcart */
  const getOpenTrigger = () => {
    const selectors = [
      '[data-upcart-open]',
      '[data-upcart-cart-open]',
      '.upcart-open-cart',
      '.upcart-cart-button',
      '[aria-controls="UpcartPopup"]'
    ];

    for (
      const selector of selectors
    ) {
      const el =
        document.querySelector(
          selector
        );

      if (
        el &&
        !el.closest(
          '[data-throne-upcart-drawer]'
        ) &&
        !el.closest(
          '.throne-header'
        )
      ) {
        return el;
      }
    }

    return null;
  };

  const openUpcart = () => {
    const trigger =
      getOpenTrigger();

    if (!trigger) return false;

    trigger.click();

    setTimeout(
      applySkin,
      100
    );

    return true;
  };

  document.addEventListener(
    'click',
    (event) => {
      const cartLink =
        event.target.closest(
          '.throne-header__desktop-cart,.throne-header__mobile-action-box--cart'
        );

      if (!cartLink) return;

      if (openUpcart()) {
        event.preventDefault();
        event.stopPropagation();

        const mobileClose =
          document.querySelector(
            '.throne-header__mobile-menu.is-open [data-mobile-menu-close]'
          );

        if (mobileClose) {
          mobileClose.click();
        }
      }
    },
    true
  );

  /* Re-apply after Upcart
     quantity/discount/protection/
     subscription rerenders. */
  const observer =
    new MutationObserver(
      (mutations) => {
        const relevant =
          mutations.some((m) => {
            const target =
              m.target;

            if (
              target instanceof
                Element &&
              target.closest?.(
                '#UpcartPopup'
              )
            ) {
              return true;
            }

            return Array.from(
              m.addedNodes
            ).some((node) => {
              return (
                node instanceof
                  Element &&
                (
                  node.id ===
                    'UpcartPopup' ||
                  node.querySelector?.(
                    '#UpcartPopup'
                  )
                )
              );
            });
          });

        if (relevant) {
          scheduleApply();
        }
      }
    );

  const start = () => {
    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'aria-checked',
          'aria-pressed',
          'class'
        ]
      }
    );

    applySkin();

    /* Product carousel already
       dispatches this event after
       AJAX add-to-cart. */
    document.addEventListener(
      'throne:product-added',
      () => {
        setTimeout(() => {
          openUpcart();
          scheduleApply();
        }, 120);
      }
    );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();